import React from 'react';
import { styled } from '@mui/material/styles';
import { Button, Divider, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icon } from '@sdb/planning-ui';

interface LoadingErrorProps {
  reFetch?: (props?: any) => unknown;
  content?: string;
}

const StyledPaper = styled(Paper)(({ theme }) => ({
  '& .header': {
    display: 'flex',
    padding: theme.spacing(4),
    gap: theme.spacing(4)
  },
  '& .content': {
    padding: theme.spacing(2)
  },
  '& .actions': {
    display: 'flex',
    justifyContent: 'end',
    padding: theme.spacing(4)
  }
}));

export const LoadingError: React.FC<LoadingErrorProps> = ({
  reFetch,
  content
}) => {
  const { t } = useTranslation();

  return (
    <StyledPaper>
      <div className="header">
        <Icon type="triangle-exclamation" color="warning" />
        <Typography variant="h6">{t('loadingError.header')}</Typography>
      </div>

      <Divider />

      <Typography variant="body1" className="content">
        {content ?? t('loadingError.contentDefault')}
      </Typography>

      <div className="actions">
        <Button variant="contained" color="warning" onClick={reFetch}>
          <Icon type="arrow-rotate-right" />
        </Button>
      </div>
    </StyledPaper>
  );
};
